import { createSvgIcon } from '@mui/material/utils';

export const CloseIcon = createSvgIcon(
    <path d='M18.6412 7.09129C19.1196 6.61288 19.1196 5.83722 18.6412 5.35881C18.1628 4.8804 17.3871 4.8804 16.9087 5.35881L12 10.2675L7.09131 5.35881C6.6129 4.8804 5.83724 4.8804 5.35882 5.35881C4.88041 5.83722 4.88041 6.61288 5.35882 7.09129L10.2675 12L5.35881 16.9087C4.8804 17.3871 4.8804 18.1628 5.35881 18.6412C5.83722 19.1196 6.61288 19.1196 7.09129 18.6412L12 13.7325L16.9087 18.6412C17.3871 19.1196 18.1628 19.1196 18.6412 18.6412C19.1196 18.1628 19.1196 17.3871 18.6412 16.9087L13.7325 12L18.6412 7.09129Z' />,
    'Close'
);
